import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const LogoutButton = (props) => {
  const { authentication } = props;
  const btnClasses = cx({
    'page-header__logout': true,
    'page-header__logout--pl': COUNTRY === 'PL',
    'pull-right': COUNTRY !== 'PL',
  });
  if (authentication && authentication.isAuthenticated && !authentication.isLoading) {
    return (
      <button
        type="button"
        className={btnClasses}
        onClick={props.logout}
      />
    );
  }
  return null;
};

LogoutButton.propTypes = {
  authentication: PropTypes.object,
  logout: PropTypes.func,
};

export default LogoutButton;
